export const cogitoCredentials = {
  UserPoolId: process.env.REACT_APP_AWS_COGNITO_USERPOOL_ID!,
  IdentityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITYPOOL_ID!,
  ClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID!,
};
//export const googleMapAPI ="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyCkIym4kIbbX1xhRU7tOPd5UO8Gb_eQxGs"
//export const googleMapAPI =
//  `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY!}`;

export const googleMapAPI =
    `https://maps.googleapis.com/maps/api/js?v=3.64&libraries=geometry,drawing,places&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY!}`;

export const VisualCrossKey = process.env.REACT_APP_VISUAL_CROSSING_KEY!